/*
  Christmas pre-order notice for the custom builder (Enhancify bb-app-layer).
  Config comes from window.doggXmasNotice, printed in layout/theme.liquid from
  Theme settings > Christmas pre-order notice. Product page and cart are
  handled server-side in snippets/christmas-notice.liquid.

  The builder is a third-party bundle, so this only adds to its DOM:
   1. size dropdown options "... Pre-Order (Expected: DD/MM/YYYY)" get a suffix
   2. "Pre-order item. Expected: DD/MM/YYYY" on chosen parts is replaced by the
      Christmas text (kept small so it fits on 2 lines). The purple card-grid
      pre-order label is deliberately left alone.
   3. a banner at the top of the parts column while any chosen part qualifies
  Everything is idempotent, so re-running on every DOM change is safe.
*/
(function () {
  var C = window.doggXmasNotice;
  if (!C) return;

  function pad(n) { n = String(n); return n.length < 2 ? '0' + n : n; }
  function toNum(str) {
    var m = /(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(str || '');
    return m ? parseInt(m[3] + pad(m[2]) + pad(m[1]), 10) : 0;
  }

  var cutoff = toNum(C.cutoff);
  var hideAfter = toNum(C.hideAfter);
  var now = new Date();
  var today = parseInt(now.getFullYear() + pad(now.getMonth() + 1) + pad(now.getDate()), 10);
  if (!cutoff || (hideAfter && today > hideAfter)) return;

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  // Returns the arrival-date label (e.g. "14 Dec") if the text contains an
  // "Expected" date on/after the cutoff, otherwise null.
  function qualifying(text) {
    if (!/Expected/i.test(text || '')) return null;
    var m = /(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(text);
    if (!m) return null;
    if (toNum(m[0]) < cutoff) return null;
    return parseInt(m[1], 10) + ' ' + MONTHS[parseInt(m[2], 10) - 1];
  }

  // Builder part text - [date] becomes e.g. "14 December"
  function noticeText(label) {
    return String(C.text || '').replace('[date]', label || '');
  }

  function run() {
    // 1. Size dropdown options
    var opts = document.querySelectorAll('select.custom-builder-quick option');
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      if (o.getAttribute('data-xmas')) continue;
      if (qualifying(o.textContent)) {
        o.appendChild(document.createTextNode(' ' + (C.optionSuffix || '')));
        o.setAttribute('data-xmas', '1');
      }
    }

    // 2. Chosen-part rows and card image labels
    var labels = document.querySelectorAll('.component-oos');
    for (var j = 0; j < labels.length; j++) {
      var el = labels[j];
      var existing = el.querySelector('.dogg-xmas-inline');
      var label = qualifying(el.textContent.replace(existing ? existing.textContent : '', ''));
      if (label && !existing) {
        var s = document.createElement('span');
        s.className = 'dogg-xmas-inline';
        s.textContent = noticeText(label);
        el.appendChild(s);
      } else if (!label && existing) {
        existing.parentNode.removeChild(existing);
      }
      // Hide the builder's own "Pre-order item. Expected: date" text so the
      // Christmas text replaces it (left in the DOM so React can still manage it)
      if (label) el.classList.add('dogg-xmas-replaced');
      else el.classList.remove('dogg-xmas-replaced');
    }

    // 3. Build banner at the top of the parts column
    var any = false;
    var rows = document.querySelectorAll('.component-oos');
    for (var k = 0; k < rows.length; k++) {
      if (qualifying(rows[k].textContent)) { any = true; break; }
    }
    var column = document.querySelector('.custom-builder__landing-page__components');
    var banner = document.getElementById('DoggXmasBuilderBanner');
    if (any && column) {
      if (!banner) {
        banner = document.createElement('p');
        banner.id = 'DoggXmasBuilderBanner';
        banner.className = 'dogg-xmas-notice dogg-xmas-notice--builder';
        banner.setAttribute('role', 'note');
        banner.textContent = C.builderBanner || '';
      }
      if (banner.parentNode !== column) column.insertBefore(banner, column.firstChild);
    } else if (banner) {
      banner.parentNode.removeChild(banner);
    }
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; run(); }, 120);
  }

  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
